/**
 * Partie 2 du COPSOQ III (les échelles scorées) : conversion entre la saisie
 * du formulaire — par question, l'index de l'option retenue en chaîne, `""`
 * sans réponse — et les réponses stockées, dénormalisées avec leur score.
 * Le jeu de questions est celui de la version de la passation.
 */

import type { Copsoq3Reponse, Copsoq3Reponses } from "../../lib/types";
import type { Copsoq3Question } from "./copsoq3-pompiers-data";

export type SaisiePartie2 = Record<string, string>;

export function saisiePartie2Initiale(
  questions: readonly Copsoq3Question[],
  reponses: readonly Copsoq3Reponse[],
): SaisiePartie2 {
  const saisie: SaisiePartie2 = Object.fromEntries(
    questions.map((q) => [q.name, ""]),
  );
  for (const r of reponses) {
    const q = questions.find((q) => q.name === r.name);
    if (!q) continue;
    const optIndex = q.options.findIndex(
      (o) => o.label === r.reponse && o.score === r.score,
    );
    saisie[r.name] = optIndex >= 0 ? optIndex.toString() : "";
  }
  return saisie;
}

export function versReponsesPartie2(
  questions: readonly Copsoq3Question[],
  saisie: SaisiePartie2,
): Copsoq3Reponses {
  return questions.reduce<Copsoq3Reponses>((acc, q) => {
    const raw = saisie[q.name];
    if (!raw) return acc;
    const opt = q.options[parseInt(raw)];
    if (!opt) return acc;
    return {
      ...acc,
      [q.name]: {
        name: q.name,
        question: q.question,
        echelle: q.echelle,
        domaine: q.domaine,
        reponse: opt.label,
        score: opt.score,
      },
    };
  }, {});
}
